/**
 * The console uses the admin app's own design language, not a separate one.
 *
 * The first version of this was dark, on the theory that a staff tool should
 * look like a different tool. Rendered next to the real sidebar it just looked
 * broken — half the screen cream, half near-black — and a surface that looks
 * like a bolted-on prototype does not read as "purpose-built", it reads as
 * unfinished. Which is the opposite of the point.
 *
 * So the distinction is carried by the things that actually differ: an explicit
 * XAIR STAFF frame, identifiers set in mono because staff copy them into
 * queries, severity colours that are semantic rather than brand, and density
 * tuned for reading a whole account at once. Same materials, different tool.
 *
 * Severity is deliberately NOT the brand red. #c01e2e is XAir's colour and it
 * is everywhere in this app; if a critical flag were the same red as the "Add
 * School" button, nothing would read as urgent.
 */
export const C = {
  bg:        "#FAF7F2",   // warm cream ground, matches the dashboard
  panel:     "#ffffff",
  panelHi:   "#F7F4EF",
  border:    "#F2EDE4",
  borderMid: "#e5ddd0",
  text:      "#1a1a1a",
  textDim:   "#6b6b6b",
  textFaint: "#9a9a9a",
  brand:     "#c01e2e",

  // Semantic, never decorative.
  high:      "#c01e2e",
  medium:    "#d97706",
  low:       "#6b6b6b",
  good:      "#16a34a",

  mono: "'SF Mono', 'Menlo', 'Consolas', monospace",
};

export const KIND_LABEL = {
  member: "Member",
  school_student: "School student",
  school_staff: "School staff",
  school: "School",
  booking: "Booking",
};

/** A dot colour per entity kind, so a mixed result list is scannable. */
export const KIND_COLOR = {
  member: "#2563eb",
  school_student: "#16a34a",
  school_staff: "#d97706",
  school: "#7c3aed",
  booking: "#c01e2e",
};

export const panel = {
  background: C.panel,
  border: `1px solid ${C.border}`,
  borderRadius: 10,
};
